import { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.js";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function PdfViewerAllPages({ fileUrl }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!fileUrl) return;

    const loadPDF = async () => {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const localUrl = URL.createObjectURL(blob);

      const pdf = await pdfjsLib.getDocument(localUrl).promise;
      const container = containerRef.current;

      container.innerHTML = ""; // Clear old pages

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);

          // ✅ Natural PDF scale based on device pixel ratio (Retina quality)
          const scale = window.devicePixelRatio || 1;
  
       
        const viewport = page.getViewport({ scale });

        // Create Canvas for each page
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style.width = "100%";
        canvas.style.height = "auto"; // ✅ keeps natural proportions

        container.appendChild(canvas);

        const renderContext = {
          canvasContext: context,
          viewport,
        };

        await page.render(renderContext).promise;
      }
    };

    loadPDF();
  }, [fileUrl]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        overflowY: "auto",
      }}
    />
  );
}
